<nav aria-label="Page navigation example" *ngIf="count > 0">
    <ul class="pagination">
        <li class="page-item" [ngClass]="{'disabled':page === 1}">
            <button class="page-link cursor-pointer" (click)="onPrev()" aria-label="Previous">
                <nb-icon icon="arrow-ios-back-outline"></nb-icon>
            </button>
        </li>

        <li class="page-item" *ngFor="let pageNum of getPages()" [ngClass]="{'active': pageNum === page || pageNum === 0}"><a class="page-link cursor-pointer" (click)="onPage(pageNum)">{{pageNum}}</a></li>

        <li class="page-item" [ngClass]="{'disabled':lastPage()}">
            <button class="page-link cursor-pointer" (click)="onNext(true)" aria-label="Next">
                <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
            </button>
        </li>
    </ul>
</nav>